// extracted by mini-css-extract-plugin
export default {"commentColumn":"_7ee3409cfa5c2459","commentTextArea":"cdfed57525e9ac7f","colWithHistory":"_70baf6c73085c404"};